import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { Reviews } from '../components/Reviews';
import { WhyUs } from '../components/WhyUs';
import { GoalsGrid } from '../components/GoalsGrid';
import { ScienceSection } from '../components/ScienceSection';
import { LabTesting } from '../components/LabTesting';
import { FAQ } from '../components/FAQ';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-background" data-id="element-1347">
      <AnnouncementBar data-id="element-1348" />
      <Header data-id="element-1349" />
      <main data-id="element-1350">
        <Hero data-id="element-1351" />
        <TrustStrip data-id="element-1352" />
        <FeaturedProducts data-id="element-1353" />
        <Reviews data-id="element-1354" />
        <WhyUs data-id="element-1355" />
        <GoalsGrid data-id="element-1356" />
        <ScienceSection data-id="element-1357" />
        <LabTesting data-id="element-1358" />
        <FAQ data-id="element-1359" />
        <Newsletter data-id="element-1360" />
      </main>
      <Footer data-id="element-1361" />
    </div>;
}